module.exports = __webpack_public_path__ + "static/media/Engage-PEO_logo_Final.b6b714b1.png";